import { render, staticRenderFns } from "./aromaten.vue?vue&type=template&id=55c30016&"
import script from "./aromaten.vue?vue&type=script&lang=js&"
export * from "./aromaten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports